export function stringToTitleCase(text) {
    const result = text.replace(/([A-Z])/g, " $1");
    const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
    if (finalResult[0] == ' ' && text[0] != '') {
        return finalResult.substring(1);
    }
    return finalResult;
}